import { useEffect, useRef } from "react";
import { Check, ChevronDown } from "lucide-react";
import type { GeneralProductionPlan } from "../../../shared/general-production";
import { generalDate } from "./general-production-format";

export function GeneralProductionWeekPicker({ plans, selected, onSelect, loading = false }: {
  plans: GeneralProductionPlan[]; selected: GeneralProductionPlan | null; onSelect: (id: string) => void; loading?: boolean;
}) {
  const root = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const dismiss = (event: PointerEvent) => {
      if (event.target instanceof Node && root.current && !root.current.contains(event.target)) root.current.open = false;
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && root.current?.open) {
        root.current.open = false; root.current.querySelector("summary")?.focus();
      }
    };
    document.addEventListener("pointerdown", dismiss); document.addEventListener("keydown", escape);
    return () => { document.removeEventListener("pointerdown", dismiss); document.removeEventListener("keydown", escape); };
  }, []);
  return <details className="pack39-week-picker" ref={root}>
    <summary aria-label={`Üretim haftası: ${selected?.sheetName ?? (loading ? "Plan yükleniyor…" : "Plan seçin")}`}>
      <span>{selected?.sheetName ?? (loading ? "Plan yükleniyor…" : "Plan seçin")}</span><ChevronDown size={13} aria-hidden="true" />
    </summary>
    <div className="pack39-week-menu" aria-label="Üretim haftaları">
      <p>Üretim haftası seç</p>
      {plans.map((plan) => <button type="button" key={plan.id} aria-current={selected?.id === plan.id ? "true" : undefined}
        onClick={() => { onSelect(plan.id); if (root.current) root.current.open = false; root.current?.querySelector("summary")?.focus(); }}>
        <span><strong>{plan.sheetName} · Sürüm {plan.version}</strong><span>{generalDate(plan.weekStart)} – {generalDate(plan.weekEnd)}</span></span>
        <small>{plan.status === "SOURCE" ? "Excel · Onay bekliyor" : plan.status === "ACTIVE" ? "Etkin" : "Arşiv"}</small>
        {selected?.id === plan.id ? <Check size={16} aria-hidden="true" /> : <span className="pack39-week-check-space" />}
      </button>)}
      {!plans.length ? <p>{loading ? "Plan listesi alınıyor…" : "Kaydedilmiş üretim planı yok."}</p> : null}
    </div>
  </details>;
}
